import {
    mdiPiggyBank,
    mdiCashRegister,
    mdiCreditCardCheck,
    mdiCreditCardMinus,
    mdiFileChartOutline,
} from "@mdi/js"

import { i18n } from "@lingui/core"
import {
    BackgroundBlue,
    BackgroundDeepTurquoise,
    BackgroundRed,
    BackgroundTurquoise,
} from "components/dashboard/dashboard-card"

export class EconomicCardInfo
{
    public constructor(
        public background: any,
        public avatarIcon: string,
        public avatarColour: string,
        public title: string,
    )
    {
    }
}

export class EconomicCardsData
{
    public static readonly TOTAL_REVENUE = new EconomicCardInfo(
        BackgroundBlue,
        mdiPiggyBank,
        "#27458D",
        /*i18n*/i18n._({id: "economic.card.title.total-revenue", message: "FATTURATO TOTALE"})
    )
    public static readonly COMMISSIONS_CASHIN = new EconomicCardInfo(
        BackgroundTurquoise,
        mdiCashRegister,
        "#48B9B6",
        /*i18n*/i18n._({id: "economic.card.title.commissions-cashin", message: "COMMISSIONI INCASSATE"})
    )
    public static readonly COMMISSIONS_PAID = new EconomicCardInfo(
        BackgroundDeepTurquoise,
        mdiCreditCardCheck,
        "#229299",
        /*i18n*/i18n._({id: "economic.card.title.commissions-paid", message: "COMMISSIONI PAGATE"})
    )
    public static readonly TOTAL_EXPENSES = new EconomicCardInfo(
        BackgroundRed,
        mdiCreditCardMinus,
        "#E5565A",
        /*i18n*/i18n._({id: "economic.card.title.total-expenses", message: "COSTI TOTALI"})
    )
    public static readonly AVERAGE_COMMISSIONS_CASHIN = new EconomicCardInfo(
        BackgroundTurquoise,
        mdiFileChartOutline,
        "#48B9B6",
        /*i18n*/i18n._({id: "economic.card.title.average-commissions-cashin", message: "IMPORTO MEDIO PER CONTRATTO"})
    )
    public static readonly AVERAGE_COMMISSIONS_PAID = new EconomicCardInfo(
        BackgroundDeepTurquoise,
        mdiFileChartOutline,
        "#229299",
        /*i18n*/i18n._({id: "economic.card.title.average-commissions-paid", message: "IMPORTO MEDIO PER CONTRATTO"})
    )
}
